import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Logo from "../components/Logo";
import { LOGO_WELCOME_MODAL } from "../config/logoSizes";
import { useApp } from "../context/AppContext";
import { isIOSApp, IOS_MAX_HOURS, getAppleProducts, purchaseApplePlan } from "../utils/appleIAP";
const TERMS_AR = `\u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0627\u0644\u0623\u062D\u0643\u0627\u0645 \u2013 \u062A\u0623\u0648\u064A\u0644 AI
\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B: 2025
1. \u0627\u0644\u062A\u0639\u0631\u064A\u0641\u0627\u062A
\u062A\u0634\u064A\u0631 "\u0627\u0644\u0634\u0631\u0643\u0629" \u0625\u0644\u0649 \u0634\u0631\u0643\u0629 \u0633\u064A\u0631\u0648 \u0627\u0644\u062A\u062C\u0627\u0631\u064A\u0629 (\u0634\u0631\u0643\u0629 \u0630\u0627\u062A \u0645\u0633\u0624\u0648\u0644\u064A\u0629 \u0645\u062D\u062F\u0648\u062F\u0629) \u0648\u0645\u0642\u0631\u0647\u0627 \u0641\u064A \u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629.
\u062A\u0634\u064A\u0631 "\u0627\u0644\u062E\u062F\u0645\u0629" \u0625\u0644\u0649 \u0645\u0646\u0635\u0629 \u062A\u0623\u0648\u064A\u0644 AI.
\u064A\u0634\u064A\u0631 "\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645" \u0625\u0644\u0649 \u0623\u064A \u0634\u062E\u0635 \u064A\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u062E\u062F\u0645\u0629.
2. \u0637\u0628\u064A\u0639\u0629 \u0627\u0644\u062E\u062F\u0645\u0629
\u062A\u0623\u0648\u064A\u0644 AI \u0647\u0648 \u0645\u0633\u0627\u0639\u062F \u064A\u0639\u0645\u0644 \u0628\u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A \u064A\u0647\u062F\u0641 \u0625\u0644\u0649:
- \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0641\u064A \u062A\u0641\u0633\u064A\u0631 \u0627\u0644\u0623\u062D\u0644\u0627\u0645
- \u062A\u062D\u0644\u064A\u0644 \u0627\u0644\u0631\u0645\u0648\u0632 \u0648\u0627\u0644\u0645\u0639\u0627\u0646\u064A
- \u062A\u0642\u062F\u064A\u0645 \u0645\u062D\u062A\u0648\u0649 \u0625\u0631\u0634\u0627\u062F\u064A \u0645\u0628\u0646\u064A \u0639\u0644\u0649 \u0645\u0635\u0627\u062F\u0631 \u0645\u0639\u0631\u0641\u064A\u0629
\u0625\u062E\u0644\u0627\u0621 \u0645\u0633\u0624\u0648\u0644\u064A\u0629:
\u0627\u0644\u062E\u062F\u0645\u0629 \u0644\u0623\u063A\u0631\u0627\u0636 \u0625\u0631\u0634\u0627\u062F\u064A\u0629 \u0641\u0642\u0637 \u0648\u0644\u0627 \u062A\u0645\u062B\u0644 \u0641\u062A\u0648\u0649 \u0634\u0631\u0639\u064A\u0629 \u0623\u0648 \u062A\u0634\u062E\u064A\u0635\u064B\u0627 \u0646\u0641\u0633\u064A\u064B\u0627 \u0623\u0648 \u0637\u0628\u064A\u064B\u0627\u060C \u0648\u0644\u0627 \u064A\u062C\u0628 \u0627\u0644\u0627\u0639\u062A\u0645\u0627\u062F \u0639\u0644\u064A\u0647\u0627 \u0641\u064A \u0627\u062A\u062E\u0627\u0630 \u0642\u0631\u0627\u0631\u0627\u062A \u0645\u0635\u064A\u0631\u064A\u0629.
3. \u0642\u0628\u0648\u0644 \u0627\u0644\u0634\u0631\u0648\u0637
\u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0644\u0644\u062E\u062F\u0645\u0629\u060C \u0641\u0625\u0646\u0643 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0634\u0631\u0648\u0637. \u0625\u0630\u0627 \u0644\u0645 \u062A\u0648\u0627\u0641\u0642\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0642\u0641 \u0639\u0646 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645.
4. \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A
- \u064A\u062A\u0637\u0644\u0628 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u0639\u0628\u0631 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0623\u0648 \u062C\u0648\u062C\u0644
- \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0633\u0627\u0628\u0647
- \u064A\u062D\u0642 \u0644\u0644\u0634\u0631\u0643\u0629 \u062A\u0639\u0644\u064A\u0642 \u0623\u0648 \u062D\u0630\u0641 \u0627\u0644\u062D\u0633\u0627\u0628 \u0639\u0646\u062F \u0625\u0633\u0627\u0621\u0629 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645
5. \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u0627\u062A \u0648\u0627\u0644\u062F\u0641\u0639
- \u062A\u0648\u0641\u0631 \u0627\u0644\u062E\u062F\u0645\u0629 \u0627\u0634\u062A\u0631\u0627\u0643\u0627\u062A \u0628\u0627\u0644\u0633\u0627\u0639\u0629 \u0623\u0648 \u0634\u0647\u0631\u064A\u064B\u0627
- \u064A\u0648\u062C\u062F \u062A\u062C\u0631\u0628\u0629 \u0645\u062C\u0627\u0646\u064A\u0629 (10 \u0631\u0633\u0627\u0626\u0644 \u0644\u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637 \u0641\u064A \u0627\u0644\u062D\u064A\u0627\u0629)
- \u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A \u063A\u064A\u0631 \u0642\u0627\u0628\u0644\u0629 \u0644\u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0628\u0639\u062F \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645
6. \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062E\u062F\u0645\u0629
\u064A\u0645\u0646\u0639: \u0625\u0633\u0627\u0621\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062E\u062F\u0645\u0629\u060C \u0625\u062F\u062E\u0627\u0644 \u0645\u062D\u062A\u0648\u0649 \u0645\u062E\u0627\u0644\u0641 \u0623\u0648 \u0645\u0633\u064A\u0621\u060C \u0645\u062D\u0627\u0648\u0644\u0629 \u0627\u062E\u062A\u0631\u0627\u0642 \u0627\u0644\u0646\u0638\u0627\u0645\u060C \u0623\u0648 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062E\u062F\u0645\u0629 \u0628\u0634\u0643\u0644 \u063A\u064A\u0631 \u0642\u0627\u0646\u0648\u0646\u064A.
7. \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A
\u0642\u062F \u064A\u062A\u0645 \u062C\u0645\u0639: \u0627\u0644\u0627\u0633\u0645\u060C \u0627\u0644\u0639\u0645\u0631\u060C \u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629\u060C \u0645\u062D\u062A\u0648\u0649 \u0627\u0644\u0623\u062D\u0644\u0627\u0645.
\u062A\u0633\u062A\u062E\u062F\u0645 \u0647\u0630\u0647 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u062A\u062D\u0633\u064A\u0646 \u0627\u0644\u062E\u062F\u0645\u0629. \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0645\u0633\u0624\u0648\u0644 \u0639\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u064A\u062F\u062E\u0644\u0647\u0627.
8. \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A
\u0627\u0644\u0646\u062A\u0627\u0626\u062C \u0642\u062F \u062A\u0643\u0648\u0646 \u063A\u064A\u0631 \u062F\u0642\u064A\u0642\u0629\u060C \u063A\u064A\u0631 \u0645\u0643\u062A\u0645\u0644\u0629\u060C \u0623\u0648 \u0645\u062E\u062A\u0644\u0641\u0629 \u0645\u0646 \u0634\u062E\u0635 \u0644\u0622\u062E\u0631.
9. \u0627\u0644\u0645\u0644\u0643\u064A\u0629 \u0627\u0644\u0641\u0643\u0631\u064A\u0629
\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0642\u0648\u0642 \u0645\u062D\u0641\u0648\u0638\u0629 \u0644\u0644\u0634\u0631\u0643\u0629 \u0648\u0644\u0627 \u064A\u062C\u0648\u0632 \u0646\u0633\u062E \u0623\u0648 \u0625\u0639\u0627\u062F\u0629 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0628\u062F\u0648\u0646 \u0625\u0630\u0646.
10. \u062A\u062D\u062F\u064A\u062F \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629
\u0627\u0644\u0634\u0631\u0643\u0629 \u063A\u064A\u0631 \u0645\u0633\u0624\u0648\u0644\u0629 \u0639\u0646 \u0642\u0631\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0623\u0648 \u0623\u064A \u0623\u0636\u0631\u0627\u0631 \u0646\u0627\u062A\u062C\u0629 \u0639\u0646 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645.
11. \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062E\u062F\u0645\u0629
\u064A\u062D\u0642 \u0644\u0644\u0634\u0631\u0643\u0629 \u062A\u0639\u0644\u064A\u0642 \u0623\u0648 \u0625\u0646\u0647\u0627\u0621 \u0627\u0644\u062E\u062F\u0645\u0629 \u0641\u064A \u0623\u064A \u0648\u0642\u062A \u062F\u0648\u0646 \u0625\u0634\u0639\u0627\u0631 \u0645\u0633\u0628\u0642.
12. \u0627\u0644\u062A\u0639\u062F\u064A\u0644\u0627\u062A
\u064A\u0645\u0643\u0646 \u062A\u0639\u062F\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0634\u0631\u0648\u0637 \u0641\u064A \u0623\u064A \u0648\u0642\u062A\u060C \u0648\u064A\u0639\u062F \u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0627\u0644\u062A\u062D\u062F\u064A\u062B\u0627\u062A.
13. \u0627\u0644\u0642\u0627\u0646\u0648\u0646 \u0627\u0644\u062D\u0627\u0643\u0645
\u062A\u062E\u0636\u0639 \u0647\u0630\u0647 \u0627\u0644\u0634\u0631\u0648\u0637 \u0644\u0623\u0646\u0638\u0645\u0629 \u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629.
14. \u0627\u0644\u0644\u063A\u0629
\u0641\u064A \u062D\u0627\u0644 \u0627\u0644\u062A\u0639\u0627\u0631\u0636\u060C \u062A\u0643\u0648\u0646 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0647\u064A \u0627\u0644\u0645\u0639\u062A\u0645\u062F\u0629.
15. \u0627\u0644\u062A\u0648\u0627\u0635\u0644
TaweelAi.Support@gmail.com`;
const TERMS_EN = `Terms & Conditions \u2013 Taweel AI
Last Updated: 2025
1. Definitions
"Company" refers to Ciro Trading Company (LLC), based in the Kingdom of Saudi Arabia.
"Service" refers to Taweel AI platform.
"User" refers to anyone using the Service.
2. Nature of the Service
Taweel AI is an AI-powered assistant designed to:
- Interpret dreams
- Analyze symbols and meanings
- Provide general insights based on reference materials
Disclaimer:
The Service is for guidance purposes only and does not constitute religious fatwa, medical, or psychological advice. It should not be relied upon for critical decisions.
3. Acceptance of Terms
By using the Service, you agree to these Terms. If you do not agree, you must stop using the Service.
4. Accounts
- Registration via email or Google is required
- Users are responsible for their account
- The Company may suspend or terminate accounts for misuse
5. Subscriptions & Payments
- The Service offers hourly and monthly plans
- A free trial (10 messages) is available one time only per account \u2014 it never resets
- Payments are non-refundable after use
6. Acceptable Use
Users must not: misuse the Service, submit harmful or illegal content, attempt to hack or disrupt the system, or use the Service unlawfully.
7. User Data
The Service may collect: Name, Age, Social status, Dream content.
This data is used to improve the Service. Users are responsible for the data they provide.
8. AI Disclaimer
Results may be inaccurate, incomplete, or vary between individuals.
9. Intellectual Property
All rights are owned by the Company and may not be reused without permission.
10. Limitation of Liability
The Company is not responsible for user decisions or any damages resulting from use.
11. Termination
The Company may suspend or terminate access at any time without notice.
12. Changes
Terms may be updated at any time. Continued use means acceptance.
13. Governing Law
These Terms are governed by the laws of Saudi Arabia.
14. Language
In case of conflict, the Arabic version prevails.
15. Contact
TaweelAi.Support@gmail.com`;
const PRIVACY_AR = `\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629 \u2013 Taweel AI
\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B: 2025
1. \u0627\u0644\u0645\u0642\u062F\u0645\u0629
Taweel AI \u0647\u0648 \u0645\u0633\u0627\u0639\u062F \u0630\u0643\u0627\u0621 \u0627\u0635\u0637\u0646\u0627\u0639\u064A \u064A\u0633\u0627\u0639\u062F \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0641\u064A \u062A\u0641\u0633\u064A\u0631 \u0627\u0644\u0623\u062D\u0644\u0627\u0645 \u0628\u0646\u0627\u0621\u064B \u0639\u0644\u0649 \u0645\u0635\u0627\u062F\u0631 \u0625\u0633\u0644\u0627\u0645\u064A\u0629 \u0648\u0645\u0628\u0627\u062F\u0626 \u0646\u0641\u0633\u064A\u0629.
\u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645\u0643 \u0644\u0644\u062E\u062F\u0645\u0629\u060C \u0641\u0625\u0646\u0643 \u062A\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0647\u0630\u0647 \u0627\u0644\u0633\u064A\u0627\u0633\u0629.
2. \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u064A \u0646\u062C\u0645\u0639\u0647\u0627
\u0646\u0642\u0648\u0645 \u0628\u062C\u0645\u0639 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u062F\u0646\u0649 \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u0642\u0637:
- \u0627\u0644\u0627\u0633\u0645 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)
- \u0627\u0644\u0639\u0645\u0631 \u0648\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u0627\u062C\u062A\u0645\u0627\u0639\u064A\u0629 (\u0627\u062E\u062A\u064A\u0627\u0631\u064A)
- \u0648\u0635\u0641 \u0627\u0644\u062D\u0644\u0645 \u0648\u0627\u0644\u0645\u0634\u0627\u0639\u0631 \u0627\u0644\u0645\u0631\u062A\u0628\u0637\u0629 \u0628\u0647
- \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062D\u0633\u0627\u0628 (\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0648\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u0645\u0634\u0641\u0631\u0629)
3. \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A
\u0646\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0646 \u0623\u062C\u0644: \u062A\u0641\u0633\u064A\u0631 \u0627\u0644\u0623\u062D\u0644\u0627\u0645\u060C \u062A\u062D\u0633\u064A\u0646 \u062F\u0642\u0629 \u0627\u0644\u0630\u0643\u0627\u0621 \u0627\u0644\u0627\u0635\u0637\u0646\u0627\u0639\u064A\u060C \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0646\u0638\u0627\u0645.
\u0644\u0627 \u064A\u062A\u0645 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0623\u064A \u0623\u063A\u0631\u0627\u0636 \u0623\u062E\u0631\u0649.
4. \u062D\u0645\u0627\u064A\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A
\u0646\u0633\u062A\u062E\u062F\u0645 \u0623\u0646\u0638\u0645\u0629 \u062D\u0645\u0627\u064A\u0629 \u0645\u062A\u0642\u062F\u0645\u0629\u060C \u0644\u0643\u0646 \u0644\u0627 \u064A\u0648\u062C\u062F \u0646\u0638\u0627\u0645 \u0622\u0645\u0646 100%.
5. \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A
\u064A\u062A\u0645 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u0642\u0637 \u0644\u0644\u0645\u062F\u0629 \u0627\u0644\u0644\u0627\u0632\u0645\u0629\u060C \u0648\u064A\u0645\u0643\u0646\u0643 \u0637\u0644\u0628 \u062D\u0630\u0641\u0647\u0627 \u0641\u064A \u0623\u064A \u0648\u0642\u062A.
6. \u0645\u0634\u0627\u0631\u0643\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A
\u0646\u062D\u0646 \u0644\u0627 \u0646\u0628\u064A\u0639 \u0628\u064A\u0627\u0646\u0627\u062A\u0643.
\u0642\u062F \u064A\u062A\u0645 \u0645\u0634\u0627\u0631\u0643\u062A\u0647\u0627 \u0641\u0642\u0637 \u0641\u064A \u0627\u0644\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u0642\u0627\u0646\u0648\u0646\u064A\u0629 \u0623\u0648 \u0644\u0645\u0646\u0639 \u0625\u0633\u0627\u0621\u0629 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645.
7. \u0625\u062E\u0644\u0627\u0621 \u0627\u0644\u0645\u0633\u0624\u0648\u0644\u064A\u0629
\u0627\u0644\u062E\u062F\u0645\u0629 \u062A\u0642\u062F\u0645 \u0625\u0631\u0634\u0627\u062F\u0627\u062A \u0641\u0642\u0637\u060C \u0648\u0644\u064A\u0633\u062A \u062C\u0647\u0629 \u062F\u064A\u0646\u064A\u0629 \u0631\u0633\u0645\u064A\u0629 \u0648\u0644\u0627 \u062A\u0639\u062A\u0628\u0631 \u062D\u0642\u064A\u0642\u0629 \u0645\u0637\u0644\u0642\u0629.
8. \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u0627\u062A \u0648\u0627\u0644\u0645\u062F\u0641\u0648\u0639\u0627\u062A
- \u0642\u062F \u062A\u062A\u0648\u0641\u0631 \u062E\u0637\u0637 \u0645\u062F\u0641\u0648\u0639\u0629 \u0628\u0627\u0644\u0633\u0627\u0639\u0629 \u0623\u0648 \u0634\u0647\u0631\u064A\u064B\u0627
- \u062A\u0648\u062C\u062F \u062A\u062C\u0631\u0628\u0629 \u0645\u062C\u0627\u0646\u064A\u0629 (10 \u0631\u0633\u0627\u0626\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629 \u0641\u0642\u0637 \u0644\u0643\u0644 \u062D\u0633\u0627\u0628 \u0648\u0644\u0627 \u062A\u062A\u062C\u062F\u062F \u0623\u0628\u062F\u064B\u0627)
- \u0644\u0627 \u064A\u0648\u062C\u062F \u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0625\u0644\u0627 \u0625\u0630\u0627 \u062A\u0637\u0644\u0628 \u0627\u0644\u0646\u0638\u0627\u0645 \u0630\u0644\u0643
9. \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0627\u0644\u062E\u062F\u0645\u0629
\u064A\u062D\u0642 \u0644\u0646\u0627 \u0625\u064A\u0642\u0627\u0641 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0645\u0633\u064A\u0626\u0629.
10. \u0627\u0644\u0643\u0648\u0643\u064A\u0632
\u0646\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0643\u0648\u0643\u064A\u0632 \u0644\u062A\u062D\u0633\u064A\u0646 \u0627\u0644\u0623\u062F\u0627\u0621 \u0648\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644.
11. \u062D\u0642\u0648\u0642\u0643
\u064A\u0645\u0643\u0646\u0643 \u0637\u0644\u0628 \u0627\u0644\u0627\u0637\u0644\u0627\u0639 \u0639\u0644\u0649 \u0628\u064A\u0627\u0646\u0627\u062A\u0643\u060C \u062A\u0639\u062F\u064A\u0644\u0647\u0627\u060C \u0623\u0648 \u062D\u0630\u0641\u0647\u0627.
\u0644\u0644\u062A\u0648\u0627\u0635\u0644: TaweelAi.Support@gmail.com
12. \u0627\u0644\u062A\u062D\u062F\u064A\u062B\u0627\u062A
\u0642\u062F \u064A\u062A\u0645 \u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0633\u064A\u0627\u0633\u0629\u060C \u0648\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u064A\u0639\u0646\u064A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629.`;
const PRIVACY_EN = `Privacy Policy \u2013 Taweel AI
Last Updated: 2025
1. Introduction
Taweel AI ("we", "our", or "us") is an AI-powered assistant designed to help users interpret dreams based on Islamic sources and psychological principles.
By using our platform, you agree to this Privacy Policy.
2. Information We Collect
We collect only necessary data, including:
- Optional: Name, age, social status
- Dream descriptions and related emotions
- Account data (email and encrypted password)
3. How We Use Data
Your data is used to: provide dream interpretation, improve AI responses, and ensure platform security.
We do NOT use your data for unrelated purposes.
4. Data Protection
We use secure systems and industry standards to protect your data.
However, no system is completely secure.
5. Data Retention
We keep your data only as long as needed.
You may request deletion at any time.
6. Data Sharing
We do NOT sell your data.
We may share data only when required by law or to prevent misuse.
7. Disclaimer
Taweel AI provides guidance only.
It is NOT a religious authority and should not be treated as absolute truth.
8. Payments & Subscriptions
- Hourly and monthly paid plans are available
- Free trial: 10 messages, one time per account \u2014 NEVER resets
- No refunds unless required by law
9. User Responsibility
We may suspend accounts that misuse the service.
10. Cookies
We use basic cookies for login and performance improvement.
11. Your Rights
You may request: Access to your data, Correction, or Deletion.
Contact: TaweelAi.Support@gmail.com
12. Updates
We may update this policy. Continued use means acceptance.`;
const LegalModal = ({ title, content, isAr, onClose }) => <div
  className="modal-overlay"
  onClick={(e) => e.target === e.currentTarget && onClose()}
  style={{ zIndex: 2e3 }}
>
    <div className="modal-box legal-modal-box" role="dialog" aria-modal="true" aria-label={title}>
      <div className="legal-modal-header">
        <h2 className="legal-modal-title">{title}</h2>
        <button className="legal-modal-close" onClick={onClose} aria-label="Close">✕</button>
      </div>
      <div className="legal-modal-body" dir={isAr ? "rtl" : "ltr"}>
        <pre className="legal-modal-pre">{content}</pre>
      </div>
    </div>
  </div>;
const LegalLinks = ({ isAr }) => {
  const { t, i18n } = useTranslation();
  const [modal, setModal] = useState(null);
  const lang = i18n.language;
  const termsContent = lang === "ar" ? TERMS_AR : TERMS_EN;
  const privacyContent = lang === "ar" ? PRIVACY_AR : PRIVACY_EN;
  const btnStyle = {
    background: "none",
    border: "none",
    padding: 0,
    color: "var(--text-3)",
    cursor: "pointer",
    fontSize: "inherit",
    fontFamily: "inherit",
    textDecoration: "underline",
    transition: "color .14s"
  };
  return <>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        <button
    style={btnStyle}
    onMouseEnter={(e) => e.currentTarget.style.color = "var(--accent)"}
    onMouseLeave={(e) => e.currentTarget.style.color = "var(--text-3)"}
    onClick={() => setModal("terms")}
  >{t("termsOfUse")}</button>
        <span style={{ opacity: 0.4 }}>·</span>
        <button
    style={btnStyle}
    onMouseEnter={(e) => e.currentTarget.style.color = "var(--accent)"}
    onMouseLeave={(e) => e.currentTarget.style.color = "var(--text-3)"}
    onClick={() => setModal("privacy")}
  >{t("privacyPolicy")}</button>
      </span>
      {modal === "terms" && <LegalModal title={t("termsOfUse")} content={termsContent} isAr={lang === "ar"} onClose={() => setModal(null)} />}
      {modal === "privacy" && <LegalModal title={t("privacyPolicy")} content={privacyContent} isAr={lang === "ar"} onClose={() => setModal(null)} />}
    </>;
};
const Feature = ({ icon, bold, label }) => <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 0", borderBottom: "1px solid var(--border)" }}>
    <div style={{
  width: 36,
  height: 36,
  borderRadius: 10,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 18,
  background: "var(--bg-hover)"
}}>{icon}</div>
    <span style={{ fontSize: 13.5, color: "var(--text-1)" }}>
      <strong style={{ fontWeight: 700 }}>{bold} </strong>{label}
    </span>
  </div>;
const WelcomeScreen = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isAr = i18n.language === "ar";
  const { checkAuth } = useApp();
  // iOS app: purchases must go through Apple IAP (App Review 3.1.1) — EdfaPay serves web/Android
  const iosApp = isIOSApp();
  const maxHours = iosApp ? IOS_MAX_HOURS : 48;
  const [appleProducts, setAppleProducts] = useState(null);
  const [legalModal, setLegalModal] = useState(null);
  const [visible, setVisible] = useState(false);
  const [loadingPlan, setLoadingPlan] = useState(null);
  const [planInfo, setPlanInfo] = useState(null);
  const [planLoading, setPlanLoading] = useState(true);
  const [hours, setHours] = useState(1);
  const [hoursInput, setHoursInput] = useState("1");
  const [alert, setAlert] = useState(null);
  useEffect(() => {
    if (!iosApp) return;
    getAppleProducts()
      .then((p) => {
        setAppleProducts(p);
        // Prices render as "…" whenever StoreKit gives us nothing. Say so out
        // loud instead of leaving a silent placeholder the user can't act on.
        if (p?.error) {
          setAlert(isAr
            ? "تعذّر تحميل الأسعار من App Store. تأكد من إعداد المنتجات في App Store Connect."
            : "Could not load App Store prices. Check the products are configured in App Store Connect.");
        }
      })
      .catch((e) => {
        console.error("[AppleIAP] product load rejected:", e);
        setAppleProducts(null);
      });
  }, [iosApp, isAr]);
  const hourlyPlan = planInfo?.plans?.find((p) => p.id === "hourly");
  const monthlyPlan = planInfo?.plans?.find((p) => p.id === "monthly");
  const hourlyPrice = hourlyPlan?.amount || 1;
  const monthlyPrice = monthlyPlan?.amount || 25;
  const currencyCode = planInfo?.locale?.currency || "USD";
  const dailyIfHourly = hourlyPrice * 24;
  const dailyIfMonthly = monthlyPrice / 30;
  const savingsPercent = Math.round((dailyIfHourly - dailyIfMonthly) / dailyIfHourly * 100);
  // On iOS the displayed price must be StoreKit's priceString (App Store review requirement)
  const hourPriceLabel = iosApp ? appleProducts?.hour ? hours > 1 ? `${hours} × ${appleProducts.hour.priceString}` : appleProducts.hour.priceString : "..." : null;
  const monthlyPriceLabel = iosApp ? appleProducts?.monthly?.priceString || "..." : null;
  const formatPrice = (value, currency = "USD") => {
    try {
      return new Intl.NumberFormat(i18n.language || "en-US", {
        style: "currency",
        currency,
        currencyDisplay: "symbol",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch {
      return `${Number(value || 0).toFixed(2)} ${currency}`;
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 60);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    let active = true;
    axios.get("/api/payment/plans").then((res) => {
      if (active) setPlanInfo(res.data);
    }).catch(() => {
    }).finally(() => {
      if (active) setPlanLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);
  const goToChat = () => {
    localStorage.setItem("taweel_welcome_seen", "1");
    navigate("/chat", { replace: true });
  };
  // The user can dismiss Apple's payment sheet themselves — not an error worth a red alert
  const isUserCancelled = (err) => /cancel|cancelled|canceled/i.test(String(err?.message || err?.code || ""));
  const handleBuyHourly = async () => {
    setLoadingPlan("hourly");
    setAlert(null);
    try {
      if (iosApp) {
        await purchaseApplePlan("hourly", hours);
        await checkAuth();
        navigate("/chat", { replace: true });
        return;
      }
      const res = await axios.post("/api/payment/create-session", { hours });
      const paymentUrl = res?.data?.paymentUrl;
      if (!paymentUrl) throw new Error("Missing payment URL");
      window.location.assign(paymentUrl);
    } catch (err) {
      if (!isUserCancelled(err)) setAlert(err.response?.data?.message || t("paymentFailed"));
      setLoadingPlan(null);
    }
  };
  const handleBuyMonthly = async () => {
    setLoadingPlan("monthly");
    setAlert(null);
    try {
      if (iosApp) {
        await purchaseApplePlan("monthly");
        await checkAuth();
        navigate("/chat", { replace: true });
        return;
      }
      const res = await axios.post("/api/payment/buy-monthly");
      const paymentUrl = res?.data?.paymentUrl;
      if (!paymentUrl) throw new Error("Missing payment URL");
      window.location.assign(paymentUrl);
    } catch (err) {
      if (!isUserCancelled(err)) setAlert(err.response?.data?.message || t("paymentFailed"));
      setLoadingPlan(null);
    }
  };
  const termsContent = isAr ? TERMS_AR : TERMS_EN;
  const privacyContent = isAr ? PRIVACY_AR : PRIVACY_EN;
  return <>
      {}
      <div style={{
    position: "fixed",
    inset: 0,
    background: "var(--bg-overlay)",
    backdropFilter: "blur(10px)",
    zIndex: 1200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px 16px",
    opacity: visible ? 1 : 0,
    transition: "opacity .3s ease"
  }}>
        {}
        <div style={{
    background: "var(--bg-card)",
    border: "1px solid var(--border2)",
    borderRadius: 28,
    padding: "24px 22px 18px",
    width: "100%",
    maxWidth: 860,
    maxHeight: "96vh",
    overflowY: legalModal ? "hidden" : "auto",
    boxShadow: "var(--shadow), 0 0 100px rgba(61,186,110,.13)",
    transform: visible ? "scale(1) translateY(0)" : "scale(.95) translateY(20px)",
    transition: "transform .38s cubic-bezier(.4,0,.2,1)",
    display: "flex",
    flexDirection: "column",
    gap: 0
  }}>
          {}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, marginBottom: 14 }}>
            <Logo variant="full" size={LOGO_WELCOME_MODAL} className="auth-logo-img welcome-plans-brand-logo" />
            <p style={{ fontSize: 20, fontWeight: 800, color: "var(--text-1)", margin: "4px 0 2px", textAlign: "center", fontFamily: "'Outfit',sans-serif" }}>
              {t("welcomeTitle")}
            </p>
            <p style={{ fontSize: 13, color: "var(--text-2)", textAlign: "center", margin: 0, lineHeight: 1.5, maxWidth: 440 }}>
              {t("welcomeSub")}
            </p>
          </div>
          {}
          {!planLoading && planInfo && <p style={{ textAlign: "center", fontSize: 12, color: "var(--text-3)", margin: "0 0 10px" }}>
              {isAr ? `\u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0628\u0639\u0645\u0644\u0629 ${planInfo?.locale?.countryName || "\u062F\u0648\u0644\u062A\u0643"} (${currencyCode})` : `Prices shown in ${planInfo?.locale?.countryName || "your country"} currency (${currencyCode})`}
            </p>}
          {alert && <div className="form-alert error" style={{ marginBottom: 10 }}>{alert}</div>}
          {}
          <div style={{ display: "flex", gap: 14, alignItems: "stretch", flexWrap: "wrap" }}>
            {}
            <div style={{ flex: "1 1 200px", minWidth: 180 }}>
              <Feature icon="💬" bold={t("welcome10bold")} label={t("welcome10label")} />
              <Feature icon="🌙" bold={t("welcomeDreamBold")} label={t("welcomeDreamLabel")} />
              <Feature icon="🔒" bold={t("welcomePrivacyBold")} label={t("welcomePrivacyLabel")} />
              <Feature icon="⚡" bold={t("welcomeUpgradeBold")} label={t("welcomeUpgradeLabel")} />
            </div>
            {}
            <div className="welcome-plans-inner" style={{ flex: "2 1 420px", display: "flex", gap: 10, alignItems: "stretch", flexWrap: "nowrap" }}>
              {}
              <div style={{
    flex: 1,
    minWidth: 120,
    background: "var(--bg-base)",
    border: "1.5px solid var(--border2)",
    borderRadius: 18,
    padding: "14px 14px 12px",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    opacity: 0.72
  }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-3)", textTransform: "uppercase", letterSpacing: 1 }}>🆓 {t("freePlan")}</div>
                <div style={{ fontSize: 24, fontWeight: 800, color: "var(--text-2)", fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>{formatPrice(0, currencyCode)}</div>
                <div style={{ fontSize: 11, color: "var(--text-3)", marginBottom: 4 }}>{t("freePlanNote")}</div>
                <div style={{ fontSize: 12, color: "var(--text-3)", flex: 1 }}>
                  <div>✓ {t("welcomeFreeF1")}</div>
                  <div>✓ {t("welcomeFreeF2")}</div>
                </div>
                <button
    onClick={goToChat}
    style={{
      width: "100%",
      padding: "9px",
      marginTop: 8,
      background: "transparent",
      color: "var(--text-2)",
      border: "1.5px solid var(--border2)",
      borderRadius: 10,
      fontSize: 12.5,
      fontWeight: 600,
      fontFamily: "inherit",
      cursor: "pointer",
      transition: "all .15s"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.borderColor = "var(--border3)";
      e.currentTarget.style.color = "var(--text-1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.borderColor = "var(--border2)";
      e.currentTarget.style.color = "var(--text-2)";
    }}
  >{t("welcomeContinueFree")}</button>
              </div>
              {}
              <div style={{
    flex: 1.1,
    minWidth: 130,
    background: "var(--bg-base)",
    border: "1.5px solid var(--border2)",
    borderRadius: 18,
    padding: "14px 14px 12px",
    display: "flex",
    flexDirection: "column",
    gap: 4
  }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text-2)", textTransform: "uppercase", letterSpacing: 1 }}>⏱ {t("hourlyPlan")}</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: "var(--accent)", fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>
                  {hourPriceLabel ?? formatPrice(hours * hourlyPrice, currencyCode)}
                  <span style={{ fontSize: 12, fontWeight: 400, color: "var(--text-3)", marginLeft: 4 }}>/ {hours === 1 ? isAr ? "\u0633\u0627\u0639\u0629" : "hr" : isAr ? "\u0633\u0627\u0639\u0627\u062A" : "hrs"}</span>
                </div>
                {}
                <div style={{ display: "flex", alignItems: "center", gap: 6, margin: "4px 0" }}>
                  <button className="hours-btn" onClick={() => {
    const n = Math.max(1, hours - 1);
    setHours(n);
    setHoursInput(String(n));
  }} style={{ width: 26, height: 26, fontSize: 16 }}>−</button>
                  <input
    type="number"
    value={hoursInput}
    min={1}
    max={maxHours}
    onChange={(e) => {
      setHoursInput(e.target.value);
      const n = parseInt(e.target.value, 10);
      if (!isNaN(n) && n >= 1 && n <= maxHours) setHours(n);
    }}
    onBlur={() => {
      const n = parseInt(hoursInput, 10);
      if (isNaN(n) || n < 1) {
        setHours(1);
        setHoursInput("1");
      } else if (n > 48) {
        setHours(48);
        setHoursInput("48");
      } else {
        setHours(n);
        setHoursInput(String(n));
      }
    }}
    style={{
      flex: 1,
      textAlign: "center",
      fontSize: 13,
      fontWeight: 700,
      color: "var(--text-1)",
      background: "var(--bg-base)",
      border: "1px solid var(--border2)",
      borderRadius: 7,
      padding: "3px 4px",
      outline: "none",
      width: "100%",
      fontFamily: "inherit"
    }}
  />
                  <span style={{ fontSize: 10, color: "var(--text-3)" }}>{isAr ? "\u0633\u0627\u0639\u0629" : "hr"}</span>
                  <button className="hours-btn" onClick={() => {
    const n = Math.min(maxHours, hours + 1);
    setHours(n);
    setHoursInput(String(n));
  }} style={{ width: 26, height: 26, fontSize: 16 }}>+</button>
                </div>
                <div style={{ fontSize: 12, color: "var(--text-2)", flex: 1 }}>✨ {t("unlimitedMessages")}</div>
                <button onClick={handleBuyHourly} disabled={loadingPlan === "hourly" || (iosApp && !appleProducts?.hour)} className="plan-btn" style={{ marginTop: 8, padding: "9px", fontSize: 12.5 }}>
                  {loadingPlan === "hourly" ? <><div className="spinner" />{isAr ? "\u062C\u0627\u0631\u064A..." : iosApp ? "Processing..." : "Redirecting..."}</> : `${isAr ? "\u0627\u062F\u0641\u0639" : "Pay"} \u2014 ${hourPriceLabel ?? formatPrice(hours * hourlyPrice, currencyCode)}`}
                </button>
              </div>
              {}
              <div style={{
    flex: 1.2,
    minWidth: 140,
    background: "var(--accent-glow)",
    border: "1.5px solid var(--border3)",
    borderRadius: 18,
    padding: "14px 14px 12px",
    display: "flex",
    flexDirection: "column",
    gap: 4,
    position: "relative"
  }}>
                <div style={{
    position: "absolute",
    top: -11,
    left: "50%",
    transform: "translateX(-50%)",
    background: "var(--accent)",
    color: "#fff",
    fontSize: 10,
    fontWeight: 700,
    padding: "3px 12px",
    borderRadius: 10,
    whiteSpace: "nowrap"
  }}>⚡ {isAr ? "\u0627\u0644\u0623\u0641\u0636\u0644 \u0642\u064A\u0645\u0629" : "Best Value"}</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: "var(--accent)", textTransform: "uppercase", letterSpacing: 1 }}>👑 {t("proPlan")}</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: "var(--accent)", fontFamily: "'Outfit',sans-serif", lineHeight: 1 }}>
                  {monthlyPriceLabel ?? (planLoading ? "..." : formatPrice(monthlyPrice, currencyCode))}
                  <span style={{ fontSize: 12, fontWeight: 400, color: "var(--text-3)", marginLeft: 4 }}>/ {isAr ? "\u0634\u0647\u0631" : "mo"}</span>
                </div>
                <div style={{ fontSize: 12, color: "var(--text-2)", flex: 1 }}>
                  <div>✨ {t("proUnlimited")}</div>
                  {!iosApp && !planLoading && savingsPercent > 0 && <div style={{
    marginTop: 6,
    padding: "5px 8px",
    background: "rgba(61,186,110,.1)",
    border: "1px solid rgba(61,186,110,.2)",
    borderRadius: 8,
    fontSize: 11
  }}>
                      <span style={{ color: "var(--accent)", fontWeight: 800 }}>🔥 {isAr ? `\u0648\u0641\u0631 ${savingsPercent}%` : `Save ${savingsPercent}%`}</span>
                      <br />
                      <span style={{ color: "var(--text-3)", fontSize: 10.5 }}>
                        {isAr ? `\u0628\u062F\u0644 ${formatPrice(dailyIfHourly, currencyCode)}/\u064A\u0648\u0645 \u2192 ${formatPrice(dailyIfMonthly, currencyCode)}/\u064A\u0648\u0645` : `vs ${formatPrice(dailyIfHourly, currencyCode)}/day \u2192 ${formatPrice(dailyIfMonthly, currencyCode)}/day`}
                      </span>
                    </div>}
                </div>
                <button onClick={handleBuyMonthly} disabled={loadingPlan === "monthly" || (iosApp && !appleProducts?.monthly)} className="plan-btn pro-btn" style={{ marginTop: 8, padding: "9px", fontSize: 12.5 }}>
                  {loadingPlan === "monthly" ? <><div className="spinner" />{isAr ? "\u062C\u0627\u0631\u064A..." : iosApp ? "Processing..." : "Redirecting..."}</> : `${isAr ? "\u0627\u0634\u062A\u0631\u0643" : "Subscribe"} \u2014 ${monthlyPriceLabel ?? (planLoading ? "..." : formatPrice(monthlyPrice, currencyCode))}`}
                </button>
              </div>
            </div>
          </div>
          {}
          <div style={{ textAlign: "center", marginTop: 14, display: "flex", flexDirection: "column", gap: 6, alignItems: "center" }}>
            <button
    onClick={goToChat}
    style={{
      background: "none",
      border: "none",
      color: "var(--text-3)",
      fontSize: 12.5,
      fontFamily: "inherit",
      cursor: "pointer",
      textDecoration: "underline",
      transition: "color .14s",
      padding: 0
    }}
    onMouseEnter={(e) => e.currentTarget.style.color = "var(--text-2)"}
    onMouseLeave={(e) => e.currentTarget.style.color = "var(--text-3)"}
  >{t("welcomeCancelAnytime")}</button>
            <div style={{ fontSize: 12, color: "var(--text-3)" }}>
              <button
    onClick={() => setLegalModal("terms")}
    style={{
      background: "none",
      border: "none",
      color: "var(--text-3)",
      cursor: "pointer",
      fontSize: 12,
      fontFamily: "inherit",
      textDecoration: "underline",
      padding: 0,
      transition: "color .14s"
    }}
    onMouseEnter={(e) => e.currentTarget.style.color = "var(--accent)"}
    onMouseLeave={(e) => e.currentTarget.style.color = "var(--text-3)"}
  >{t("termsOfUse")}</button>
              <span style={{ margin: "0 7px", opacity: 0.4 }}>·</span>
              <button
    onClick={() => setLegalModal("privacy")}
    style={{
      background: "none",
      border: "none",
      color: "var(--text-3)",
      cursor: "pointer",
      fontSize: 12,
      fontFamily: "inherit",
      textDecoration: "underline",
      padding: 0,
      transition: "color .14s"
    }}
    onMouseEnter={(e) => e.currentTarget.style.color = "var(--accent)"}
    onMouseLeave={(e) => e.currentTarget.style.color = "var(--text-3)"}
  >{t("privacyPolicy")}</button>
            </div>
          </div>
        </div>
      </div>
      {}
      {legalModal === "terms" && <LegalModal title={t("termsOfUse")} content={termsContent} isAr={isAr} onClose={() => setLegalModal(null)} />}
      {legalModal === "privacy" && <LegalModal title={t("privacyPolicy")} content={privacyContent} isAr={isAr} onClose={() => setLegalModal(null)} />}
    </>;
};
var stdin_default = WelcomeScreen;
export {
  LegalLinks,
  LegalModal,
  PRIVACY_AR,
  PRIVACY_EN,
  TERMS_AR,
  TERMS_EN,
  stdin_default as default
};
